(() => {
  const collections = [
    {handle:'cotton-canvas-boards',title:'Cotton Canvas Boards',major:'boards'},
    {handle:'watercolor-canvas-boards',title:'Watercolor Canvas Boards',major:'boards'},
    {handle:'frame',title:'Master Cotton Stretched Canvas',major:'stretched'},
    {handle:'canvas-magnetic-canvas',title:'Magnetic Canvas',major:'boards'},
    {handle:'stretched-mini-canvas',title:'Mini Canvas',major:'stretched'},
    {handle:'3308-canvas',title:'Studio Cotton Stretched Canvas',major:'stretched'},
    {handle:'3dcotton-canvas',title:'3D Cotton Stretched Canvas',major:'stretched'},
    {handle:'cotton-canvas',title:'Artist Cotton Stretched Canvas',major:'stretched'},
    {handle:'stretched-watercolor-stretched-canvas',title:'Watercolor Stretched Canvas',major:'stretched'},
    {handle:'stretched-linen',title:'Linen Stretched Canvas',major:'stretched'},
    {handle:'stretched-cotton-stretched-canvas',title:'Shaped Cotton Stretched Canvas',major:'stretched'}
  ];
  function init(root) {
    if(root.dataset.initialized) return;
    root.dataset.initialized='true';
    const labels=JSON.parse(root.querySelector('[data-cr-labels]').textContent);
    const form=root.querySelector('[data-cr-form]'), grid=root.querySelector('[data-cr-grid]');
    const status=root.querySelector('[data-cr-status]'), counter=root.querySelector('[data-cr-count]');
    const retry=root.querySelector('[data-cr-retry]'), previous=root.querySelector('[data-cr-prev]'), next=root.querySelector('[data-cr-next]');
    const products=new Map(); let page=1, loaded=0, complete=false, failed=false, running=false;
    const size=24, money=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});
    const current=new URL(location.href), preview=current.searchParams.get('preview_theme_id') || String(window.Shopify?.theme?.id || '');
    const base=window.Shopify?.routes?.root || '/';
    if(matchMedia('(max-width:999px)').matches) root.querySelector('.cr-filters').open=false;
    function options() {
      const selected=form.elements.sub.value, major=form.elements.major.value;
      form.elements.sub.replaceChildren(new Option(labels.all_collections,''));
      ['stretched','boards'].filter(m=>!major||major===m).forEach(m=>{
        const group=document.createElement('optgroup');group.label=labels[m];
        collections.filter(c=>c.major===m).forEach(c=>group.append(new Option(c.title,c.handle)));
        form.elements.sub.append(group);
      });
      form.elements.sub.value=[...form.elements.sub.options].some(o=>o.value===selected)?selected:'';
    }
    function render() {
      const major=form.elements.major.value, sub=form.elements.sub.value;
      const min=form.elements.min.value===''?0:Math.round(Number(form.elements.min.value)*100);
      const max=form.elements.max.value===''?Infinity:Math.round(Number(form.elements.max.value)*100);
      const invalid=min>max || min<0 || max<0 || !Number.isFinite(min) || (max!==Infinity && !Number.isFinite(max));
      const matches=[...products.values()].filter(p=>!invalid && (!major||p.majors.has(major)) && (!sub||p.collections.has(sub)) && p.price>=min && p.price<=max);
      const pages=Math.max(1,Math.ceil(matches.length/size));page=Math.min(page,pages);
      counter.textContent=invalid?labels.price_invalid:`${matches.length} ${complete?labels.results:labels.partial}`;
      root.querySelector('[data-cr-empty]').hidden=matches.length>0||(!complete&&!failed);
      grid.replaceChildren();
      matches.slice((page-1)*size,page*size).forEach(p=>{
        const card=document.createElement('article');card.className='cr-card';
        const a=document.createElement('a');a.href=p.url;
        if(p.image){const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.width=480;img.height=480;a.append(img);}
        const title=document.createElement('h3');title.textContent=p.title;
        const price=document.createElement('p');price.className='cr-card-price';price.textContent=`${p.priceVaries?labels.from+' ':''}${money.format(p.price/100)} USD`;
        a.append(title,price);
        if(!p.available){const stock=document.createElement('p');stock.className='cr-card-stock';stock.textContent=labels.sold_out;a.append(stock);}
        card.append(a);grid.append(card);
      });
      previous.disabled=page===1;next.disabled=page>=pages;
      root.querySelector('[data-cr-page]').textContent=`${labels.page} ${page} / ${pages}`;
      status.textContent=complete?labels.complete:failed?labels.failed:`${labels.loading} (${loaded}/${collections.length})`;
    }
    async function loadCollection(c) {
      let n=1, pages=1;
      do {
        const url=new URL(`${base}collections/${c.handle}`,location.origin);
        url.searchParams.set('view','canvas-rewards-data');url.searchParams.set('page',String(n));url.searchParams.set('currency','USD');
        if(preview)url.searchParams.set('preview_theme_id',preview);
        const response=await fetch(url.toString(),{credentials:'same-origin'});
        if(!response.ok)throw new Error(`HTTP ${response.status}`);
        const responseDocument=new DOMParser().parseFromString(await response.text(),'text/html');
        const payload=responseDocument.querySelector('script[type="application/json"][data-cr-catalog-payload]');
        if(!payload)throw new Error('Missing catalog payload');
        const data=JSON.parse(payload.textContent);
        if(data.collection!==c.handle||data.currency!=='USD'||!Array.isArray(data.products)||!Number.isInteger(data.pages)||data.pages<0)throw new Error('Invalid catalog response');
        pages=data.pages;
        for(const p of data.products){
          if(String(p.id)==='8663118086359'||!Number.isFinite(p.price)||p.price<0||!p.url?.startsWith('/'))continue;
          let entry=products.get(String(p.id));
          if(!entry){entry={...p,collections:new Set(),majors:new Set()};products.set(String(p.id),entry);}
          entry.collections.add(c.handle);entry.majors.add(c.major);
        }
        n++;render();
      } while(n<=pages);
      loaded++;render();
    }
    async function load() {
      if(running)return;running=true;failed=false;complete=false;loaded=0;products.clear();retry.hidden=true;render();
      let cursor=0;const errors=[];
      await Promise.all(Array.from({length:3},async()=>{
        while(cursor<collections.length){const c=collections[cursor++];try{await loadCollection(c);}catch(e){console.warn('Canvas catalog:',e.name,e.message);errors.push(c.handle);}}
      }));
      failed=errors.length>0;complete=!failed;running=false;retry.hidden=!failed;render();
    }
    form.addEventListener('submit',event=>event.preventDefault());
    form.addEventListener('input',event=>{if(event.target.name==='major')options();page=1;render();});
    form.addEventListener('change',event=>{if(event.target.name==='major')options();page=1;render();});
    form.addEventListener('reset',()=>setTimeout(()=>{options();page=1;render();},0));
    previous.addEventListener('click',()=>{if(page>1){page--;render();grid.scrollIntoView({block:'start'});}});
    next.addEventListener('click',()=>{page++;render();grid.scrollIntoView({block:'start'});});
    retry.addEventListener('click',load);options();load();
  }
  const start=scope=>scope.querySelectorAll('[data-cr-catalog]').forEach(init);
  start(document);document.addEventListener('shopify:section:load',e=>start(e.target));
})();
